import { render, staticRenderFns } from "./dustrunner.vue?vue&type=template&id=8697f42c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/spee2/www/univers/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8697f42c')) {
      api.createRecord('8697f42c', component.options)
    } else {
      api.reload('8697f42c', component.options)
    }
    module.hot.accept("./dustrunner.vue?vue&type=template&id=8697f42c&", function () {
      api.rerender('8697f42c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/parametric/svg-media/dustrunner.vue"
export default component.exports